import React from 'react'

import Body from '@dashboard/components/Body'
import Header from '@dashboard/components/Header'

import Content from './Content'
import SideBar from './SideBar'
import LoadingState from './LoadingState'
import Overview from './Overview'

import {
  Profile,
  LoadingStates,
  TestResultsProfile,
  ProfileContent,
} from '@dashboard/lib/types'

import css from './styles.module.scss'

interface OwnProps {
  profile: Profile | TestResultsProfile | null
  content?: ProfileContent | null
  profileId?: string
  profilePlaceholder?: boolean
  archetypeText?: string
  profileImageOveride?: JSX.Element | null
  signUpCTAText?: string
  signUpCTALink?: string
  otherCelebritiesResult?: Profile[]
  otherCelebritiesState?: LoadingStates
}

interface State {}

export default class PublicProfile extends React.Component<OwnProps, State> {
  constructor(props: OwnProps) {
    super(props)
  }

  render() {
    const {
      content,
      profile,
      profileId,
      profilePlaceholder,
      archetypeText,
      profileImageOveride,
      signUpCTAText,
      signUpCTALink,
      otherCelebritiesResult,
      otherCelebritiesState,
    } = this.props

    if (profile) {
      return (
        <div className={css.container}>
          <Header>
            <Overview
              content={content}
              profile={profile}
              id={profileId}
              profilePlaceholder={profilePlaceholder}
              archetypeText={archetypeText}
              profileImageOveride={profileImageOveride}
              signUpCTAText={signUpCTAText}
              paywallButtonLink={signUpCTALink}
            />
          </Header>
          <Body uncontained noPadding borderTop>
            <div className={css.grid}>
              <Content
                content={content}
                profile={profile}
                id={profileId}
                signUpCta={{ text: signUpCTAText || '', href: signUpCTALink }}
              />
              <SideBar
                profile={profile}
                signUpCTAText={signUpCTAText}
                signUpCTALink={signUpCTALink}
                otherCelebritiesResult={otherCelebritiesResult}
                otherCelebritiesState={otherCelebritiesState}
              />
            </div>
          </Body>
        </div>
      )
    } else {
      return <LoadingState />
    }
  }
}
